import React from 'react';

import { Button, Modal } from 'antd';
import PropTypes from 'prop-types';

import IntlMessages from 'util/IntlMessages';

const SessionClosedModal = ({ open, onAccept }) => (
  <Modal
    open={open}
    closable={false}
    maskClosable={false}
    keyboard={false}
    footer={null}
    width={400}
  >
    <div className="gx-flex-column gx-align-items-center">
      <div className="gx-flex-row gx-justify-content-center gx-mb-2 gx-text-warning">
        <span className="material-symbols-outlined">info</span>
      </div>
      <p className="gx-fs-md gx-font-weight-bold gx-text-center">
        <IntlMessages id="work.direction.auth.session.closed.title" />
      </p>
      <p className="gx-fs-md gx-text-center">
        <IntlMessages id="work.direction.auth.session.closed.message" />
      </p>
    </div>
    <div className="gx-flex-row gx-justify-content-center gx-mt-3">
      <Button className="gx-w-100" onClick={onAccept} type="primary">
        <IntlMessages id="work.direction.auth.session.closed.accept" />
      </Button>
    </div>
  </Modal>
);

SessionClosedModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onAccept: PropTypes.func.isRequired,
};

export default SessionClosedModal;
